export enum RecordingSettingsFields {
  AUTOMATIC_RECORDING = 'automaticRecording',
  SHARE_RECORDING = 'shareRecording',
  ALLOW_FORWARDING = 'allowForwarding',
  ALLOW_PLAYBACK_SPEED_CONTROL = 'allowPlaybackSpeedControl',
  ALLOW_BACKGROUND_VIDEO_PLAYBACK = 'allowBackgroundVideoPlayback',
}
